import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tgx-onboarding-implementation-progressbar-steps',
  templateUrl: './onboarding-implementation-progressbar-steps.component.html',
  styleUrls: ['./onboarding-implementation-progressbar-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OnboardingImplementationProgressbarStepsComponent {
  @Input() steps: any[] = [];
  @Input() progress = 0;
}
